import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserprofileService {

  constructor(private http : HttpClient) {

  }

  getUserList(): Observable<any> {
    const headers = new HttpHeaders();
    const httpParams = new HttpParams();

    return this.http.post(environment.API_URL + "/api/crm/userProfile/list", { headers, params: httpParams });
  }
  getCorporateUserList(): Observable<any> {
    const headers = new HttpHeaders();
    const httpParams = new HttpParams();

    return this.http.post(environment.API_URL + "/api/crm/userBookProfile/list", { headers, params: httpParams });
  }
  getCorporateUserListbyId(request:any): Observable<any> {
    const headers = new HttpHeaders();
    const httpParams = new HttpParams();

    return this.http.post(environment.API_URL + "/api/crm/userProfileManualData/list/"+request, { headers, params: httpParams });
  }
  getUserCORPORATEList(request:any): Observable<any> {
    const headers = new HttpHeaders();
    const httpParams = new HttpParams();

    return this.http.post(environment.API_URL + "/api/crm/userProfileManual/list/"+request, { headers, params: httpParams });
  }
  getEmployeeUser(): Observable<any> {
    const headers = new HttpHeaders();
    const httpParams = new HttpParams();

    return this.http.post(environment.API_URL + "/api/crm/userProfile", { headers, params: httpParams });
  }
}
